import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    columnGap: '10rem',
    rowGap: '3rem',
    marginBottom: '3rem',
    padding: '0 1rem',
    paddingTop: '3rem',
    fontSize: '0.8rem',
  },
  logo: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    height: '3rem',
    marginLeft: '2rem',
    fontSize: '1rem',
    color: 'unset',
    textDecoration: 'none',
  },
  subContainer: {
    flexGrow: 1,
    width: '36rem',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '2rem',
  },
  previousProcessContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    border: `1px solid ${theme.lighterSnowColor}`,
    borderRadius: '10px',
  },
  previousProcess: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5rem',
    '&:not(:first-child)': {
      borderTop: `1px solid ${theme.lighterSnowColor}`,
      marginTop: 0,
      paddingTop: '1.5rem',
    },
    '& > span:first-child': {
      width: '5rem',
      textTransform: 'uppercase',
      fontWeight: 500,
    },
    '& > a': {
      color: theme.lightCoralColor,
      marginLeft: 'auto',
    },
  },
  formContainer: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '2rem',
  },
  fieldsContainer: {
    padding: 0,
    marginTop: '1rem',
    border: `1px solid ${theme.lighterSnowColor}`,
    borderRadius: '10px',
    overflow: 'hidden',
  },
  fieldsHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '0.5rem',
    padding: '1.5rem',
    borderBottom: `1px solid ${theme.lighterSnowColor}`,
  },
  fieldsHeaderTitle: {
    fontSize: '0.9rem',
    fontWeight: 600,
  },
  errorMessage: {
    fontSize: '0.7rem',
    color: theme.lightCoralColor,
  },
  fieldsBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    border: 'none',
    color: theme.dimGrayColor,
    backgroundColor: theme.whiteSmokeColor,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 500,
    '& input': {
      margin: 0,
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.5rem',
    padding: '1.5rem',
    cursor: 'pointer',
    '&:not(:first-child)': {
      borderTop: `1px solid ${theme.lighterSnowColor}`,
    },
    '& > span:last-child': {
      marginLeft: 'auto',
    },
    '& input[type="radio"]': {
      display: 'none',
    },
    '& input[type="radio"] + span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '0.7rem',
      height: '0.7rem',
      borderRadius: '50%',
      border: `1px solid ${theme.gainsboroColor}`,
      backgroundColor: theme.whiteColor,
    },
    '& input[type="radio"] + span > span': {
      width: '0.4rem',
      height: '0.4rem',
      borderRadius: '50%',
      backgroundColor: theme.whiteColor,
    },
    '& input[type="radio"]:checked + span > span': {
      backgroundColor: theme.darkGrayColor,
    },
  },
  btnContainer: {
    display: 'flex',
  },
  continueBtn: (props: any) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '3.5rem',
    width: props.matches ? '50%' : '100%',
    padding: 0,
    border: 'none',
    borderRadius: '7px',
    marginLeft: 'auto',
    textDecoration: 'none',
    color: theme.whiteColor,
    background: `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
    textTransform: 'uppercase',
    fontSize: '0.9rem',
    fontWeight: 500,
    fontFamily: theme.fontFamilyArchivo,
    cursor: 'pointer',
    '&:disabled': {
      color: theme.darkGrayColor,
      background: theme.snowColor,
    },
  }),
}));

export default useStyles;
